function handleSubmit() {
  const form = document.getElementById("drawer-upsell-form");
  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  const formData = new FormData(form);
  const cart_drawer = document.querySelector("cart-drawer");
  if (cart_drawer) {
    formData.append(
      "sections",
      cart_drawer.getSectionsToRender().map((section) => section.id)
    );
    formData.append("sections_url", window.location.pathname);
    cart_drawer.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: formData.get("id"),
          cartData: response,
        });

      const cart_drawer = document.querySelector("cart-drawer");
      cart_drawer.renderContents(response);
      if (cart_drawer && cart_drawer.classList.contains("is-empty"))
        cart_drawer.classList.remove("is-empty");
    })
    .catch((e) => {
      console.error(e);
    });
}

function selectVariantById(variantId) {
  const selectElement = document.querySelector(
    '.drawer-upsell__wrapper select[name="id"]'
  );

  for (let i = 0; i < selectElement.options.length; i++) {
    if (selectElement.options[i].value == variantId) {
      selectElement.options[i].selected = true;
      selectElement.options[i].setAttribute("selected", "selected");
      selectElement.selectedIndex = i;
    } else {
      selectElement.options[i].selected = false;
      selectElement.options[i].removeAttribute("selected");
    }
  }

  const event = new Event("change");

  setTimeout(() => {
    selectElement.dispatchEvent(event);
  }, 100);
}

function updateProductPrice(variant) {
  const comparePrice = variant?.compare_at_price;
  const finalPrice = variant?.price;

  const regularPriceElement = document.querySelector(
    ".drawer-upsell__wrapper .price:not(.cart-item__old-price)"
  );
  const salePriceElement = document.querySelector(
    ".drawer-upsell__wrapper .cart-item__old-price"
  );

  if (
    regularPriceElement &&
    comparePrice &&
    comparePrice > finalPrice &&
    salePriceElement
  ) {
    const formattedComparePrice = (comparePrice / 100).toFixed(2);
    const formattedPrice = (finalPrice / 100).toFixed(2);
    regularPriceElement.textContent = `$${formattedPrice}`;
    salePriceElement.textContent = `$${formattedComparePrice}`;
  } else if (!comparePrice) {
    const formattedPrice = (finalPrice / 100).toFixed(2);
    regularPriceElement.textContent = `$${formattedPrice}`;
  }
}

function calculateOutOfStockAngle() {
  const OOSElements = document.querySelectorAll(
    ".variant-box-selector li.unavailable"
  );
  if (OOSElements.length === 0) return;
  OOSElements.forEach((box) => {
    const width = box.offsetWidth;
    const height = box.offsetHeight;
    const angle = Math.atan(height / width) * (180 / Math.PI);
    box.style.setProperty("--diagonal-angle", `${angle}deg`);
  });
}

function updateVariantSelect(upsellProduct, selectedVariantObj) {
  const selectElement = document.querySelector('select[name="id"]');

  selectElement.innerHTML = "";

  if (upsellProduct && upsellProduct.variants) {
    upsellProduct.variants.forEach((variant) => {
      const option = document.createElement("option");
      option.value = variant.id;
      option.textContent = variant.available
        ? `${variant.option1 || ""} / ${variant.option2 || ""} ${
            variant.option3 ? `/ ${variant.option3}` : ""
          }`
        : `${variant.option1 || ""} / ${variant.option2 || ""} ${
            variant.option3 ? `/ ${variant.option3}` : ""
          } - Sold Out`;
      if (!variant.available) {
        option.disabled = true;
      }
      selectElement.appendChild(option);
    });
  } else {
    console.error("No variants available for the upsell product.");
  }

  if (selectedVariantObj && selectedVariantObj.id) {
    selectVariantById(selectedVariantObj.id);
  }
}

function updateUpsellDetails(productUpsell) {
  const upsellColorElement = document.querySelector(
    ".drawer-upsell__title .option-color"
  );
  const upsellFitElement = document.querySelector(
    ".drawer-upsell__title .option-fit"
  );

  const upsellURL = document.querySelector("a.view-product-details");

  if (upsellURL) {
    upsellURL.href = productUpsell.url;
  }

  if (upsellColorElement && productUpsell.metafields.color) {
    upsellColorElement.textContent = productUpsell.metafields.color;
  }

  if (upsellFitElement && productUpsell.metafields.fit) {
    upsellFitElement.textContent = ` ${productUpsell.metafields.fit}`;
  }

  const variantColorLabelElement = document.querySelector(
    ".variant-label span"
  );
  if (variantColorLabelElement) {
    variantColorLabelElement.textContent = productUpsell.metafields.color;
  }
}

function updateLengthOptions(productVariants) {
  const waistElements = document.querySelectorAll(
    ".variant-options.option-list-1 li"
  );
  const selectedWaist = Array.from(waistElements).find((el) =>
    el.classList.contains("selected")
  )?.dataset.value;

  const filteredVariants = productVariants.filter((variant) => {
    if (variant.option1 === selectedWaist) {
      return true;
    }
    return false;
  });

  const lengthUl = document.querySelector(".variant-options.option-list-2");
  if (lengthUl) {
    updateOptionsList(lengthUl, filteredVariants);
  }
}

function bindVariantEvents(li, ul) {
  li.addEventListener("click", () => {
    ul.querySelectorAll("li").forEach((item) => {
      item.classList.remove("selected");
    });
    li.classList.add("selected");
    evaluateSelectedVariant(li);
  });

  li.addEventListener("keydown", (event) => {
    const key = event.key;
    const liItems = ul.querySelectorAll("li");
    let currentIndex = Array.from(liItems).indexOf(document.activeElement);

    if (key === "ArrowRight" || key === "ArrowLeft") {
      event.preventDefault();

      if (key === "ArrowRight") {
        currentIndex = (currentIndex + 1) % liItems.length;
      } else if (key === "ArrowLeft") {
        currentIndex = (currentIndex - 1 + liItems.length) % liItems.length;
      }

      liItems[currentIndex]?.focus();
    }

    if (key === "Enter" || key === " ") {
      if (!liItems[currentIndex]?.classList.contains("unavailable")) {
        liItems.forEach((item) => {
          item.classList.remove("selected");
        });
        liItems[currentIndex]?.classList.add("selected");
        evaluateSelectedVariant(liItems[currentIndex]);
      }
    }
  });

  li.setAttribute("tabindex", 0); // Ensure the element is focusable
}

function updateOptionsList(ul, productVariants) {
  const options = new Set();

  ul.innerHTML = "";

  productVariants.forEach((variant) => {
    if (variant.option2) {
      options.add(variant.option2);
    }
  });

  const optionsArray = [...options];

  for (let index = 0; index < optionsArray.length; index++) {
    const option = optionsArray[index];
    const li = document.createElement("li");
    li.innerHTML = `<span class="variant-title">${option}</span>`;
    li.dataset.value = option;
    li.classList.add("variant");

    if (index === 0) {
      li.classList.add("selected");
      li.setAttribute("aria-selected", "true");
    }

    ul.appendChild(li);

    bindVariantEvents(li, ul);
  }
}

function updateUpsellImages(images) {
  const imagesContainer = document.querySelector(".drawer-upsell__images");

  if (!imagesContainer) {
    console.error("Images container not found!");
    return;
  }

  imagesContainer.innerHTML = "";

  images.forEach((image, index) => {
    const img = document.createElement("img");
    img.classList.add("cart-item__image");
    img.src = image;
    img.alt = "Upsell product image" + index;
    img.width = 220;
    img.height = 220;
    imagesContainer.appendChild(img);
  });
}

function evaluateSelectedVariant(liElement) {
  const variantBox = document.querySelector(".variant-box-selector");
  const selectedVariant = {};

  const selectedColor = variantBox.querySelector("li.is-color.selected")
    ?.dataset?.value;
  const selectedFit =
    variantBox.querySelector("li.is-fit.selected")?.dataset?.value;

  let selectedVariantObj = {};

  productUpsell = upsellProducts.find((product) => {
    return (
      selectedColor.trim() == product.color.trim() &&
      selectedFit.trim() == product.fit.trim()
    );
  });

  const optionParent = liElement.parentElement;
  if (optionParent.classList.contains("option-list-2") === false) {
    updateLengthOptions(productUpsell.variants);
  }

  variantBox.querySelectorAll("ul.variant-options").forEach((ul, index) => {
    const selectedLi = ul.querySelector("li.variant.selected");
    if (selectedLi) {
      selectedVariant[`option${index + 1}`] = selectedLi.dataset.value;
    }
  });

  productUpsell.variants.forEach((variant) => {
    if (variant.option1) {
      if (variant.option1 == selectedVariant.option1) {
        if (variant.option2) {
          if (variant.option2 == selectedVariant.option2) {
            if (variant.option3) {
              if (variant.option3 == selectedVariant.option3) {
                selectedVariantObj.id = variant.id;
                selectedVariantObj.available = variant.available;
              }
            } else {
              selectedVariantObj.id = variant.id;
              selectedVariantObj.available = variant.available;
            }
          }
        } else {
          selectedVariantObj.id = variant.id;
          selectedVariantObj.available = variant.available;
        }
      }
    }
  });

  updateProductPrice(
    productUpsell.variants.find((v) => v.id == selectedVariantObj.id)
  );

  variantBox.querySelectorAll("ul").forEach((ul, _index) => {
    const ATCBtn = document.querySelector("#AddToCart-product-upsell");
    const SoldOutBtn = document.querySelector(".button.sold-out");
    ul.querySelectorAll("li").forEach((li) => {
      li.classList.remove("unavailable");
    });
    const selectedLi = ul.querySelector("li.selected");
    ATCBtn.classList.remove("disabled");
    ATCBtn.removeAttribute("disabled");

    SoldOutBtn.style.display = "none";

    if (selectedLi && !selectedVariantObj.available) {
      selectedLi.classList.add("unavailable");
      ATCBtn.classList.add("disabled");
      ATCBtn.setAttribute("disabled", "disabled");
      SoldOutBtn.style.display = "block";
      calculateOutOfStockAngle();
    }
  });

  const variantImages = [productUpsell.image, productUpsell.image2];

  updateUpsellImages(variantImages);

  updateUpsellDetails(productUpsell);

  updateVariantSelect(productUpsell, selectedVariantObj);

  return selectedVariantObj;
}

function initVariantSelector() {
  const variantBox = document.querySelector(".variant-box-selector");
  variantBox.querySelectorAll("ul").forEach((ul) => {
    let currentIndex = -1;

    ul.querySelectorAll("li").forEach((li) => {
      li.addEventListener("click", () => {
        ul.querySelectorAll("li").forEach((li) => {
          li.classList.remove("selected");
        });
        li.classList.add("selected");
        evaluateSelectedVariant(li);
      });

      li.addEventListener("keydown", (event) => {
        const key = event.key;
        const liItems = ul.querySelectorAll("li");

        if (key === "ArrowRight" || key === "ArrowLeft") {
          event.preventDefault();

          if (key === "ArrowRight") {
            currentIndex = (currentIndex + 1) % liItems.length;
          } else if (key === "ArrowLeft") {
            currentIndex = (currentIndex - 1 + liItems.length) % liItems.length;
          }

          liItems[currentIndex]?.focus();
        }

        if (key === "Enter" || key === " ") {
          if (!liItems[currentIndex]) {
            liItems[currentIndex] = li;
          }
          if (!liItems[currentIndex]?.classList.contains("unavailable")) {
            liItems.forEach((li) => {
              li.classList.remove("selected");
            });
            liItems[currentIndex]?.classList.add("selected");
            evaluateSelectedVariant(li);
          }
        }
      });

      li.setAttribute("tabindex", 0);
    });
  });

  document
    .getElementById("drawer-upsell-form")
    .addEventListener("submit", (e) => {
      e.preventDefault();
      handleSubmit();
    });
}

function runVariantSelector() {
  initVariantSelector();
}

window.addEventListener("load", function () {
  runVariantSelector();
});

subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
  setTimeout(function () {
    runVariantSelector();
  }, 1000);
});
